import React from "react";
import { Column, StatusAlert } from "@dls/web";

const InlineErrorMessage = ({ message, fullWidth = false }) => {
  return (
    <Column xs={12} md={fullWidth ? 12 : 6}>
      <StatusAlert type="alert" bodyContent={message} />
    </Column>
  );
};

export default InlineErrorMessage;
